<script>
import {Listeners} from "keysso/constants/listeners";
import WordstatApi from "keysso/api/WordstatApi";
import {DataTransformer} from "../DataTransformer";
import WordstatBaseUpdate from "./BaseUpdate.vue";

/**
 * Обновление всего проекта
 */
export default {
    name: "WordstatUpdateProject",
    extends: WordstatBaseUpdate,
    methods: {
        getListenerId() {
            return Listeners.WORDSTAT_POPUP_UPDATE_PROJECT_OPEN;
        },
        update() {
            this.loading = true;
            const payload = DataTransformer.payloadUpdate({
                frequency: this.model.frequency,
                parse_budget_cpc: this.model.parse_budget_cpc,
            });

            WordstatApi
                .updateProject(this.model.id, payload)
                .then(() => {
                    this.onClose();
                    this.$emit('onAgree', this.model.id)
                })
                .catch(error => this.alertError(error.message))
                .finally(() => this.loading = false);
        },
    },
}
</script>
